import cn from "classnames"
import React from "react"
import Spinner from "../../images/load/aera-spinner.gif"
import "./SpinnerContainer.scss"

interface ISpinnerContainerProps {
    showSpinner: boolean
    className?: string
    wrapperClassName?: string
    children?: React.ReactNode
    aboveContent?: boolean
    fullScreen?: boolean
    minHeight?: number
}

const SpinnerContainer = ({
    children,
    showSpinner,
    className,
    aboveContent,
    fullScreen,
    minHeight,
    wrapperClassName,
}: ISpinnerContainerProps) => {
    if (aboveContent) {
        return (
            <div
                className={cn(
                    "swiipe-spinner-container clearfix",
                    className,
                    fullScreen && "swiipe-spinner-container--full-screen"
                )}
                style={{ minHeight }}
            >
                <div className={cn("child-wrapper", wrapperClassName)}>{children}</div>
                {showSpinner && <div className="overlay"></div>}
                {showSpinner && <img className="spinner-img" src={Spinner} />}
            </div>
        )
    }
    return (
        <div className={cn("swiipe-spinner-container clearfix", className)} style={{ minHeight }}>
            <div className={cn("child-wrapper", wrapperClassName, { hide: showSpinner })}>{children}</div>
            {showSpinner && <img className="spinner-img" src={Spinner} />}
        </div>
    )
}

export default SpinnerContainer
